import { render, staticRenderFns } from "./ShiftsHistoryPage.vue?vue&type=template&id=7412ce2d"
import script from "./ShiftsHistoryPage.vue?vue&type=script&lang=js"
export * from "./ShiftsHistoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports